import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { FREE_OF_CHARGE_RULE_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import FreeOfChargeRuleForm from './FreeOfChargeRuleForm';
import {
  getSingleFreeOfChargeRule,
  postFreeOfChargeRule,
  putFreeOfChargeRule,
} from '../../../../actions/sales/FreeOfChargeRule';
import Loader from '../../../common/Loader';

const NewFreeOfChargeRule = ({
  breadcrumbs,
  dispatchPostFreeOfChargeRule,
  dispatchPutFreeOfChargeRule,
  dispatchGetSingleFreeOfChargeRule,
  freeOfChargeRule,
  loading,
}) => {
  useEffect(() => {
    dispatchGetSingleFreeOfChargeRule();
  }, [dispatchGetSingleFreeOfChargeRule]);

  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };

    if (formValues.userList) {
      newFormValues.userList = formValues.userList.map((user) => ({
        id: user.value || user.id,
      }));
    }

    if (freeOfChargeRule && freeOfChargeRule.get('id')) {
      dispatchPutFreeOfChargeRule(freeOfChargeRule.get('id'), newFormValues);
    } else {
      dispatchPostFreeOfChargeRule(newFormValues);
    }
  };

  let initialValues = {
    active: true,
  };

  if (freeOfChargeRule) {
    initialValues = {
      id: freeOfChargeRule.get('id'),
      active: freeOfChargeRule.get('active'),
      userList: freeOfChargeRule.get('userList')
        ? freeOfChargeRule.get('userList').map((user) => ({
            value: user.id,
            label: user.fullName || user.name || user.username,
          }))
        : [],
    };
  }

  let content;

  if (loading) {
    content = <Loader />;
  } else {
    content = (
      <FreeOfChargeRuleForm onSubmit={onSubmit} initialValues={initialValues} />
    );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Regla para Servicios a Título Gratuito"
      subtitle="Crear regla para servicios a título gratuito"
      content={content}
    />
  );
};

NewFreeOfChargeRule.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostFreeOfChargeRule: PropTypes.func.isRequired,
  dispatchGetSingleFreeOfChargeRule: PropTypes.func.isRequired,
  dispatchPutFreeOfChargeRule: PropTypes.func.isRequired,
  freeOfChargeRule: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
};

NewFreeOfChargeRule.defaultProps = {
  freeOfChargeRule: null,
  loading: false,
};

const mapDispatchToProps = {
  dispatchPostFreeOfChargeRule: postFreeOfChargeRule,
  dispatchPutFreeOfChargeRule: putFreeOfChargeRule,
  dispatchGetSingleFreeOfChargeRule: getSingleFreeOfChargeRule,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Reglas para Servicios a Título Gratuito',
      href: FREE_OF_CHARGE_RULE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
  freeOfChargeRule: SalesUnit.FreeOfChargeRule.getIn(['current', 'content']),
  loading: !SalesUnit.FreeOfChargeRule.getIn(['current', 'activity']).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewFreeOfChargeRule);
